// Patterns for third-party / browser-extension noise that isn't our code.
// Kept in a side-effect-free module (no Sentry.init) so it can be unit-tested
// in isolation. Consumed by src/lib/sentry.ts as the `ignoreErrors` option.
export const IGNORE_ERRORS: (string | RegExp)[] = [
  // Rewardful rw.js internal var, fails on iOS 26.4 Safari (ERI-609)
  "Can't find variable: _G",
  // Google Analytics race condition on slow connections
  "Can't find variable: ga",
  // Browser extension messaging (ERI-532)
  /^undefined is not an object \(evaluating '.*\.sendMessage'\)/,
  // Browser-extension content-script noise (ERI-916): an injected script's
  // messaging layer rejecting because the background it targets is gone.
  // Surfaces as an unhandled "Non-Error promise rejection captured with value:
  // Object Not Found Matching Id:N, MethodName:..., ParamCount:N". Not our code.
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
  // iOS in-app WKWebView bridge noise (Sentry MILKY-WAY-PLANNER-Z): the native
  // WKWebView message handler failing to reply to a postMessage from an in-app
  // browser (DuckDuckGo Mobile, etc.). Same string ERI-459 already handled for
  // /register; it recurs on /planner. WebView-internal, not our code.
  "WKWebView API client did not respond to this postMessage",
];

/**
 * Mirror of Sentry's `ignoreErrors` matching: a string pattern matches as a
 * substring, a RegExp matches via `.test()`. Exposed so tests can assert which
 * messages are suppressed without initializing the Sentry SDK.
 */
export function isIgnoredErrorMessage(message: string): boolean {
  return IGNORE_ERRORS.some((pattern) =>
    typeof pattern === 'string' ? message.includes(pattern) : pattern.test(message),
  );
}
